import apiClient from "../api/client";

export const getPageVersionById = async (guid: string | undefined) => {
  const res = await apiClient.get(`/api/PageVersion/${guid}`);
  return res.data;
};

export const getAllStores = async () => {
  const res = await apiClient.get("/api/Stores/GetAll");
  return res.data;
};

export const getSimulatorMenu = async (params: {
  storeNumber: string;
  pageVersionGuid: string;
}) => {
  const res = await apiClient.get(
    "/api/Page/PagesByStoreNumberAndPageVersionGuid",
    { params }
  );
  return res.data;
};
